module.exports = __webpack_public_path__ + "img/kartta-rekkaparkki.29681bf1.jpeg";